// client/extensions/transformers/Transformer.ts
var Transformer = class {
  constructor(config) {
    this.type = config.type;
    this.toContent = config.toContent;
    this.toValue = config.toValue;
  }
};
export {
  Transformer
};
